// extracted by mini-css-extract-plugin
export default {"footer":"site-footer_footer__mP69C","container":"site-footer_container__6M70r","secondaryLinks":"site-footer_secondaryLinks__9qJ5p","socialLinks":"site-footer_socialLinks__nafK4"};